module.exports = __webpack_public_path__ + "static/media/menu.7a88a46b.mp3";